import { render, staticRenderFns } from "./classExamMemS.vue?vue&type=template&id=347373ae&scoped=true&"
import script from "./classExamMemS.vue?vue&type=script&lang=js&"
export * from "./classExamMemS.vue?vue&type=script&lang=js&"
import style0 from "./classExamMemS.vue?vue&type=style&index=0&id=347373ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347373ae",
  null
  
)

export default component.exports